module.exports = "https://img.zhijierongxing.com/saas/img/shop_tab1_bg.16e11cd8.png";